/**
 * Constants for download functionality
 */
import { PDFColors, PDFDimensions, RGBColor } from './types';

/**
 * Convert hex color to RGB values
 */
export const hexToRGB = (hex: string): RGBColor => {
	const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
	if (!result || !result[1] || !result[2] || !result[3]) {
		throw new Error(`Invalid hex color: ${hex}`);
	}
	return [
		parseInt(result[1], 16),
		parseInt(result[2], 16),
		parseInt(result[3], 16)
	];
};

/**
 * PDF Color Scheme
 */
export const PDF_COLORS: PDFColors = {
	title: hexToRGB('#0051cc'),           // Dark blue
	headerBackground: hexToRGB('#e6eaf5'), // Light blue-gray
	headerText: hexToRGB('#2f323d'),      // Dark gray
	dataText: hexToRGB('#747e99'),        // Medium gray
	generationInfo: [102, 102, 102],      // Light gray
};

/**
 * PDF Layout Dimensions
 */
export const PDF_DIMENSIONS: PDFDimensions = {
	fontSize: {
		title: 20,
		header: 8,
		data: 8,
		generationInfo: 10,
	},
	spacing: {
		headerHeight: 14,
		rowHeight: 12,
		margin: 20,
		padding: 3,
	},
};

/**
 * Column width ratios for different table layouts
 */
export const COLUMN_RATIOS = {
	BILLING_TRANSACTIONS: [0.28, 0.22, 0.10, 0.15, 0.12, 0.13],
} as const;

/**
 * Export file MIME types
 */
export const MIME_TYPES = {
	CSV: 'text/csv;charset=utf-8;',
	PDF: 'application/pdf',
} as const;

/**
 * Date format options
 */
export const DATE_FORMAT_OPTIONS = {
	FULL_DATE: {
		weekday: 'long' as const,
		year: 'numeric' as const,
		month: 'long' as const,
		day: 'numeric' as const,
	},
	TIME_12H: {
		hour: '2-digit' as const,
		minute: '2-digit' as const,
	},
} as const;
